import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { TranslateConfigService } from 'src/app/core/services/translate-config.service';
import { TranslationModuleEnum } from "../../../utils/translation-modules.enum";

@Component({
  selector: 'app-team-search',
  templateUrl: './team-search.component.html',
  styleUrls: ['./team-search.component.scss']
})
export class TeamSearchComponent implements OnInit {
  translationModulesEnum = TranslationModuleEnum;
  @ViewChildren("checkboxes") checkboxes: QueryList<ElementRef>;
  _users;
  @Input()
  public set users(v: any[]) {
    this._users = v;
    this.selectedMembers = this._users.filter(u => u.checked);
  }
  // query
  @Output() onSearch = new EventEmitter();
  @Input() memberToAddType;
  @Input() lang: string;
  @Input() title: string;
  @Input() titleTranslationKey: string;
  @Input() titleTranslationModuleEnum: number;
  @Input() isRowClass: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() isLoadingUsers: boolean = false;

  @Output() onUserSelect = new EventEmitter();

  selectedMembers: any = []

  constructor(private translationService: TranslateConfigService) { }

  ngOnInit() {
    this.lang = this.translationService.getSystemLang()
  }

  onSelect(e, member) {
    if (e.target.checked) {
      this.selectedMembers.push(member)
    } else {
      this.selectedMembers = this.selectedMembers.filter(item => item.id !== member.id)
    }

    this.onUserSelect.emit(this.selectedMembers);
  }

  uncheckAll() {
    this.checkboxes.forEach((element) => {
      element.nativeElement.checked = false;
    });
  }

  randomNo(i) {
    return i % 5;
  }

  // search(event) {
  search(text) {

    // this.onSearch.emit(event?.target?.value);
    this.onSearch.emit(text);
  }

}
